/**
 * 持久化存储

 * */
import util from '@/utils/util';
import { cloneDeep } from 'lodash';

/**
 * @description 检查路径是否存在 不存在的话初始化
 * @param {Object} dbName {String} 数据库名称
 * @param {Object} path {String} 路径
 * @param {Object} defaultValue {*} 初始化默认值
 * @returns {String} 可以直接使用的路径
 */
function pathInit ({
    dbName = 'database',
    path = '',
    defaultValue = ''
}) {
    const currentPath = `${dbName}${path ? `.${path}` : ''}`;
    const value = util.db.get(currentPath).value();

    if (!(value !== undefined)) {
        util.db.set(currentPath, defaultValue).write();
    }
    return currentPath;
}

export { pathInit };

export default {
    namespaced: true,
    actions: {
        /**
         * @description 将数据存储到指定位置 | 路径不存在会自动初始化
         * @description 效果类似于取值 dbName.path = value
         * @param context context
         * @param {Object} dbName {String} 数据库名称
         * @param {Object} path {String} 存储路径
         * @param {Object} value {*} 需要存储的值
         */
        set (context, {
            dbName = 'database',
            path = '',
            value = ''
        }) {
            util.db.set(pathInit({
                dbName,
                path
            }), value).write()
        },
        /**
         * @description 获取数据
         * @description 效果类似于取值 dbName.path || defaultValue
         * @param context context
         * @param {Object} dbName {String} 数据库名称
         * @param {Object} path {String} 存储路径
         * @param {Object} defaultValue {*} 取值失败的默认值
         * @param {Object} user {Boolean} 是否区分用户
         */
        get (context, {
            dbName = 'database',
            path = '',
            defaultValue = ''
        }) {
            return new Promise(resolve => {
                resolve(cloneDeep(util.db.get(pathInit({
                    dbName,
                    path,
                    defaultValue
                })).value()))
            })
        },

        /**
         * @description 清空指定存储数据库对象
         * @param {Object} context context
         */
        databaseClear (context, {
            dbName = 'database',
            path = '',
            defaultValue = ''
        }) {
            return new Promise(resolve => {
                resolve(util.db.get(pathInit({
                    dbName,
                    path,
                    defaultValue: {}
                })))
            })
        }

    }
};
